import * as React from 'react';

import URI from 'jsuri';

import courseraRedirect from 'js/lib/coursera.redirect';

import HorizontalDomainsMenu from 'bundles/program-home/components/multiprogram/HorizontalDomainsMenu';
import { useEnterprisePermittedProducts } from 'bundles/unified-common/contexts/EnterprisePermittedProductsContext';

type Props = {
  programId: string;
  thirdPartyOrganizationId: string;
  enableSkillsInSearchAndBrowse: boolean;
};

/*
If any changes need to be made to this component, a new component is required that follows the principles of a unified component:
https://docs.google.com/document/d/1UYVcedo1viLDNyNOCZ2J3gNbM_XIVqQyOZ3VykzXQU8/edit

When we need to make use of some common functionality and/or don't have the scope to re-build a component in our unified patterns,
we import the component in a wrapper like so that clearly defines this component does not meet the standards of a unified module.

It is advised we don't do this too often, components in a 'Not Configurable' wrapper should not be iterated on and left as is.
*/
const EnterpriseDomainSelectorNotConfigurableModule = ({
  programId,
  thirdPartyOrganizationId,
  enableSkillsInSearchAndBrowse,
}: Props) => {
  const enterprisePermittedProducts = useEnterprisePermittedProducts();
  const onSelect = (href: string, topicQuery?: { query: string }) => {
    const uri = new URI(href);
    if (topicQuery) {
      uri.addQueryParam('query', topicQuery.query);
    }
    uri.addQueryParam('source', 'browse');

    courseraRedirect.setLocation(uri.toString());
  };

  return (
    <HorizontalDomainsMenu
      programId={programId}
      thirdPartyOrganizationId={thirdPartyOrganizationId}
      enableSkillsInSearchAndBrowse={enableSkillsInSearchAndBrowse}
      onSelect={onSelect}
      isLimitedContent={enterprisePermittedProducts?.isProgramLimitedContent}
    />
  );
};

export default EnterpriseDomainSelectorNotConfigurableModule;
